













































































































import Class from './c-date-picker-body';
export default Class;
